<h2 class="mb-4">Approved registration forms</h2>
<table id="dt-approved" datatable class="table row-bordered table-hover" [dtOptions]="dataTableOptions">
</table>